import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArrowRightSmallIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M7.51 13.08L8.24 13.81C8.35429 13.9236 8.50887 13.9874 8.67 13.9874C8.83113 13.9874 8.98571 13.9236 9.1 13.81L12.48 10.43C12.5375 10.3741 12.5831 10.3073 12.6143 10.2334C12.6455 10.1596 12.6616 10.0802 12.6616 10C12.6616 9.91986 12.6455 9.84051 12.6143 9.76665C12.5831 9.6928 12.5375 9.62594 12.48 9.57003L9.1 6.19003C8.98571 6.07645 8.83113 6.0127 8.67 6.0127C8.50887 6.0127 8.35429 6.07645 8.24 6.19003L7.51 6.92003C7.39879 7.03555 7.33665 7.18967 7.33665 7.35003C7.33665 7.51039 7.39879 7.66451 7.51 7.78003L9.73 10L7.51 12.22C7.39879 12.3356 7.33665 12.4897 7.33665 12.65C7.33665 12.8104 7.39879 12.9645 7.51 13.08Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowRightSmallIcon;
